export const BASKET_STATUS_LABEL = {
  ORDER_PLACED: 'Order Placed',
  PAYMENT_RECEIVED: 'Payment Received',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

export const BASKET_STATUS_COLOR = {
  ORDER_PLACED: 'blue',
  PAYMENT_RECEIVED: 'green',
  COMPLETED: 'green',
  CANCELLED: 'red',
};

export const BASKET_STATUS_FILTER_OPTIONS = Object.entries(BASKET_STATUS_LABEL).map(
  ([value, label]) => ({ label, value })
);

/** Prefer API display_label (trusted transfer-before-payment) over raw machine status. */
export const resolveBasketStatusLabel = (row) =>
  row?.display_label || BASKET_STATUS_LABEL[row?.status] || row?.status || '—';

/** Tag colour: payment pending after transfer uses amber; else map by machine status. */
export const resolveBasketStatusColor = (row) => {
  if (row?.payment_pending) return 'gold';
  return BASKET_STATUS_COLOR[row?.status] || 'default';
};
